import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import faqImg from './faq.svg';
import teacherImg from './teacher.svg';

import css from './SectionTeachersTools.module.css';

const SectionTeachersTools = ({ content }) => {

  return (<div className={css.root}>
      <div className={css.rootTitleHolder}>
        <h2 className={css.rootTitle}>
          {content?.learnMoreTitle ? (content.learnMoreTitle) :
            <FormattedMessage id='SectionTeachersTools.title' />}
        </h2>
      </div>

      <div className={css.toolsList}>
        <div className={css.toolsItem}>
          <NamedLink name='FAQPage' to={{ hash: '#general' }} className={css.link}>
            <div className={css.toolsItemImage}>
              <img src={faqImg} />
            </div>
            <FormattedMessage id='SectionTeachersTools.faqTitle' />
          </NamedLink>
        </div>
        <div className={css.toolsItem}>
          <NamedLink name='TeacherHandbookPage' className={css.link}>
            <div className={css.toolsItemImage}>
              <img src={teacherImg} />
            </div>
            <FormattedMessage id='SectionTeachersTools.teacherTitle' />
          </NamedLink>
        </div>
      </div>
    </div>);
};

export default SectionTeachersTools;
